export const products = [
  {
    id: 0,
    brand: '3G',
    name: 'Adult 26"',
    productType: 'Bike',
    color: 'Yellow',
    count: '22',
    available: '12',
    open: true,
    reserved: '6',
    inRepair: '3',
    price: '$19.29',
    description: 'Lorem ipsum',
    pictureAddress: "https://cdn.shopify.com/s/files/1/0159/3522/products/ezover_ylw_blk_1440x954.jpg?v=1448322887"
  },
  {
    id: 10,
    name: 'Adult 26"',
    brand: '3G',
    productType: 'Bike',
    color: 'Blue',
    count: '17',
    available: '3',
    open: true,
    reserved: '0',
    inRepair: '6',
    price: '$19.29',
    description: 'Lorem ipsum',
    pictureAddress: 'https://cdn.shopify.com/s/files/1/0159/3522/products/ezover_blu_blk_1440x954_1024x1024.jpg?v=1448322887'
  },
  {
    id: 1,
    name: 'Adult 26"',
    brand: '3G',
    color: 'Orange',
    count: '36',
    available: '0',
    open: false,
    reserved: '8',
    inRepair: '5',
    productType: 'Bike',
    price: '$19.29',
    description: 'Lorem ipsum',
    pictureAddress: "https://www.sefiles.net/images/library/zoom/3g-bikes-puck-324480-11.jpg"
  },
  {
    id: 2,
    name: 'Adult 26"',
    brand: '3G',
    productType: 'Bike',
    color: 'Black',
    count: '8',
    available: '6',
    open: true,
    reserved: '0',
    inRepair: '0',
    price: '$19.29',
    description: 'Lorem ipsum',
    pictureAddress: "https://www.sefiles.net/images/library/zoom/3g-bikes-puck-324480-13.jpg"
  },
  {
    id: 3,
    name: 'Adult 24"',
    color: 'Light Blue',
    brand: '3G',
    count: '14',
    available: '0',
    open: false,
    reserved: '4',
    inRepair: '2',
    productType: 'Bike',
    price: '$19.29',
    description: 'Lorem ipsum',
    pictureAddress: "https://cdn.shopify.com/s/files/1/0159/3522/products/ezover_blu_blk_1440x954_1024x1024.jpg?v=1448322887"
  },
  {
    id: 4,
    name: 'Boys 20"',
    color: 'Black',
    brand: '3G',
    count: '10',
    available: '5',
    open: true,
    reserved: '2',
    inRepair: '0',
    productType: 'Bike',
    price: '$15.49',
    description: 'Lorem ipsum',
    pictureAddress: "https://cdn.shopify.com/s/files/1/0159/3522/products/axel_blk_blu_1440x954_00dead1a-630f-4bab-8f28-f689bb81c90d.jpg?v=1544646338"
  },
  {
    id: 5,
    name: 'Girls 20"',
    color: 'Mint',
    brand: '3G',
    count: '10',
    available: '5',
    open: true,
    reserved: '2',
    inRepair: '1',
    productType: 'Bike',
    price: '$15.49',
    description: 'Lorem ipsum',
    pictureAddress: "https://cdn.shopify.com/s/files/1/0159/3522/products/gigi_grn_grn_1440x954_5db01afa-441f-46f3-ad4b-43d3a5fd0cf9.jpg?v=1519770298"
  },
  {
    id: 6,
    name: 'Kids 16"',
    color: 'Red',
    count: '19',
    available: '12',
    open: true,
    reserved: '2',
    inRepair: '3',
    productType: 'Bike',
    price: '$15.49',
    description: 'Lorem ipsum',
    pictureAddress: "https://cdn.shopify.com/s/files/1/0159/3522/products/Mini-Bruiser-Black-with-Red_1024x1024_d775b31a-9df3-47b8-8766-31744b20aab8.jpg?v=1519010614"
  },
  {
    id: 7,
    name: 'Baby Seat',
    color: 'Fits any',
    brand: 'adult bike',
    count: '4',
    available: '0',
    open: false,
    reserved: '1',
    inRepair: '0',
    productType: 'Attatchment',
    price: '$15.49',
    description: 'Lorem ipsum',
    pictureAddress: "https://dks.scene7.com/is/image/GolfGalaxy/16CPTUTXXXXXXXXXXCHL?wid=1500&fmt=pjpeg"
  },
  {
    id: 8,
    name: 'Baby Trailer',
    color: 'Fits any',
    brand: 'adult bike',
    count: '4',
    available: '4',
    open: true,
    reserved: '0',
    inRepair: '0',
    productType: 'Attatchment',
    price: '$15.49',
    description: 'Lorem ipsum',
    pictureAddress: "https://i5.walmartimages.com/asr/b12bb577-8df8-4f8f-8581-625515c306b9_1.4b26ada36fafabf3081028ae6a7bb754.jpeg?odnWidth=undefined&odnHeight=undefined&odnBg=ffffff"
  },
  {
    id: 9,
    name: 'Equip. Trailer',
    color: 'Fits any',
    brand: 'adult bike',
    count: '2',
    available: '2',
    open: true,
    reserved: '0',
    inRepair: '0',
    productType: 'Attatchment',
    price: '$15.49',
    description: 'Lorem ipsum',
    pictureAddress: "https://images-na.ssl-images-amazon.com/images/I/516oeBjG5%2BL._AC_SL1024_.jpg"
  },
]
